import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { environment } from '@env/environment';

import { DecumulationBffAuthInterceptor } from './decumulation.interceptor';
import { API_BASE_URL, Service } from './decumulationBff';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    Service,
    {
      provide: API_BASE_URL,
      useValue: `${environment.api.brasilprev.url}/desacumulacao-bff`
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DecumulationBffAuthInterceptor,
      multi: true
    }
  ],
  exports: []
})
export class DecumulationBffModule {}
